window.StrikeTreemap = (function () {

    function load(url, viewTitle) {
        console.log('Loading treemap data for:', viewTitle);

        fetch(url + '?date=' + viewTitle)
            .then(function (response) {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(function (jsonData) {
                const unionTotal = jsonData.daysByUnion.reduce(function (sum, item) { return sum + item.value; }, 0);
                const typeTotal = jsonData.daysByType.reduce(function (sum, item) { return sum + item.value; }, 0);

                const colorPalette = [
                    '#1e3a8a', '#065f46', '#7c2d12', '#581c87', '#be123c',
                    '#0e7490', '#854d0e', '#4c1d95', '#166534', '#9f1239',
                    '#0f766e', '#c2410c', '#6b21a8', '#064e3b', '#7c2d12'
                ];

                jsonData.daysByUnion.forEach(function (item, index) {
                    item.percentage = (item.value / unionTotal * 100).toFixed(1);
                    item.color = colorPalette[index % colorPalette.length];
                });
                jsonData.daysByType.forEach(function (item, index) {
                    item.percentage = (item.value / typeTotal * 100).toFixed(1);
                    item.color = colorPalette[index % colorPalette.length];
                });

                const commonConfig = {
                    chart: {
                        backgroundColor: 'transparent',
                        style: {
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                        },
                        height: '500px',
                        spacingTop: 20,
                        spacingBottom: 20,
                        events: {
                            load: function () {
                                const chart = this;
                                window.addEventListener('resize', function () {
                                    chart.reflow();
                                });
                            }
                        }
                    },
                    plotOptions: {
                        treemap: {
                            colorByPoint: true,
                            borderWidth: 3,
                            borderColor: '#ffffff',
                            borderRadius: 6,
                            shadow: { color: 'rgba(0, 0, 0, 0.1)', offsetX: 2, offsetY: 2, width: 5 },
                            dataLabels: {
                                enabled: true,
                                style: {
                                    textOutline: '3px contrast',
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    color: '#ffffff'
                                },
                                useHTML: false,
                                formatter: function () {
                                    const point = this.point;
                                    const height = point.shapeArgs ? point.shapeArgs.height : 0;
                                    const width = point.shapeArgs ? point.shapeArgs.width : 0;
                                    if (height < 35 || width < 70) return null;
                                    if (height >= 60 && width >= 100) {
                                        return '<b>' + point.name + '</b><br>' +
                                               '<span style="font-size: 13px;">' + point.value + ' days</span>';
                                    }
                                    return '<b>' + point.name + '</b><br>' + point.value;
                                }
                            },
                            states: {
                                hover: {
                                    brightness: 0.1,
                                    borderColor: '#f8f9fa',
                                    shadow: { color: 'rgba(0, 0, 0, 0.2)', offsetX: 3, offsetY: 3, width: 8 }
                                }
                            },
                            levels: [{
                                level: 1,
                                dataLabels: { enabled: true },
                                borderWidth: 3,
                                levelIsConstant: false
                            }]
                        }
                    },
                    tooltip: {
                        backgroundColor: 'rgba(17, 24, 39, 0.95)',
                        borderWidth: 0,
                        borderRadius: 10,
                        padding: 12,
                        shadow: { color: 'rgba(0, 0, 0, 0.3)', offsetX: 2, offsetY: 2, width: 6 },
                        style: { color: '#ffffff', fontSize: '14px', fontWeight: '500' },
                        useHTML: true,
                        formatter: function () {
                            return '<div style="text-align: center;">' +
                                   '<div style="font-size: 16px; font-weight: 700; margin-bottom: 6px;">' +
                                   this.point.name + '</div>' +
                                   '<div style="font-size: 20px; font-weight: 700; color: ' + this.point.color + '; margin-bottom: 4px;">' +
                                   this.point.value + '</div>' +
                                   '<div style="font-size: 12px; color: #d1d5db;">days of strike action</div>' +
                                   '<div style="font-size: 13px; color: #9ca3af; margin-top: 6px;">' +
                                   this.point.percentage + '% of total</div>' +
                                   '</div>';
                        }
                    },
                    credits: { enabled: false },
                    legend: { enabled: false },
                    responsive: {
                        rules: [{
                            condition: { maxWidth: 576 },
                            chartOptions: {
                                chart: { height: '400px', spacingTop: 50, spacingBottom: 50, spacingLeft: 50, spacingRight: 50 },
                                plotOptions: {
                                    treemap: { dataLabels: { style: { fontSize: '12px' } }, borderWidth: 2 }
                                },
                                title: { style: { fontSize: '16px' } }
                            }
                        }, {
                            condition: { minWidth: 577, maxWidth: 992 },
                            chartOptions: {
                                chart: { height: '450px' },
                                plotOptions: {
                                    treemap: { dataLabels: { style: { fontSize: '14px' } } }
                                },
                                title: { style: { fontSize: '18px' } }
                            }
                        }]
                    }
                };

                Highcharts.chart('union_highchart_container', Highcharts.merge(commonConfig, {
                    series: [{
                        type: 'treemap',
                        layoutAlgorithm: 'squarified',
                        alternateStartingDirection: true,
                        data: jsonData.daysByUnion
                    }],
                    title: {
                        text: 'Days of Strike Action by Union',
                        align: 'left',
                        margin: 30,
                        style: { fontSize: '22px', fontWeight: '700', color: '#1f2937' }
                    },
                    subtitle: {
                        text: viewTitle + ' \u2022 Total: ' + unionTotal + ' days',
                        align: 'left',
                        style: { fontSize: '14px', color: '#6b7280', fontWeight: '500' }
                    }
                }));

                Highcharts.chart('type_highchart_container', Highcharts.merge(commonConfig, {
                    series: [{
                        type: 'treemap',
                        layoutAlgorithm: 'squarified',
                        alternateStartingDirection: true,
                        data: jsonData.daysByType
                    }],
                    title: {
                        text: 'Days of Strike Action by Sector',
                        align: 'left',
                        margin: 30,
                        style: { fontSize: '22px', fontWeight: '700', color: '#1f2937' }
                    },
                    subtitle: {
                        text: viewTitle + ' \u2022 Total: ' + typeTotal + ' days',
                        align: 'left',
                        style: { fontSize: '14px', color: '#6b7280', fontWeight: '500' }
                    }
                }));
            })
            .catch(function (error) {
                console.error('Failed to load treemap data:', error);
                document.getElementById('union_highchart_container').innerHTML =
                    '<div class="alert alert-danger m-3">Failed to load chart data. Please try refreshing the page.</div>';
                document.getElementById('type_highchart_container').innerHTML =
                    '<div class="alert alert-danger m-3">Failed to load chart data. Please try refreshing the page.</div>';
            });
    }

    return { load: load };
})();
